<template>
  <v-container style="max-width: 1240px; padding-top: 100px; padding-bottom: 0;" class="header-part">
    <v-layout class="header-part__title">
      <v-flex xs12 py-2>
        <a :href="backLink" class="header-link">{{ backLinkLabel }}</a>
        <h1>{{ title }}</h1>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <h2>{{ subtitle }}</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap align-end>
      <v-flex xs12 sm6 md6 lg6 py-0>
        <v-text-field :value="policy.company" label="Страховая компания" disabled />
      </v-flex>
      <v-flex xs12 sm6 md6 lg6 py-0>
        <v-text-field :value="policy.number" label="Номер полиса" disabled />
      </v-flex>

      <v-flex xs12 sm6 md6 lg4 py-0>
        <osago-name :value="insurer.lastname" label="Фамилия" :isDisabled="true" />
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 py-0>
        <osago-name :value="insurer.firstname" label="Имя" :isDisabled="true" />
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 py-0>
        <osago-name :value="insurer.middlename" label="Отчество" :isDisabled="true" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/**
 * PolicyHeader — "тупой" компонент.
 *
 * Только отображает данные полиса и страхователя.
 * Не мутирует props, не обращается к API.
 */
export default {
  name: 'PolicyHeader',

  props: {
    /** Ссылка "Назад" */
    backLink: {
      type: String,
      default: '/list',
    },
    backLinkLabel: {
      type: String,
      default: 'Все полисы',
    },
    title: {
      type: String,
      default: 'Внесение изменений',
    },
    subtitle: {
      type: String,
      default: 'Данные полиса ОСАГО',
    },
    policy: {
      type: Object,
      required: true,
    },
    insurer: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.header-part {
  &__title {
    h1 {
      font-family: 'SFPro', 'Arial', sans-serif;
      font-size: 65px;
      color: #000000;
      line-height: 1.2;
      font-weight: 700;
    }

    .header-link {
      font-family: 'SFPro', 'Arial', sans-serif;
      display: block;
      padding: 24px 0;
      color: #00ba57 !important;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/change/components/PolicyHeader.vue